import { render } from "./FilterBtn.vue?vue&type=template&id=0c283164&scoped=true"
import script from "./FilterBtn.vue?vue&type=script&lang=js"
export * from "./FilterBtn.vue?vue&type=script&lang=js"

import "./FilterBtn.vue?vue&type=style&index=0&id=0c283164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c283164"]])

export default __exports__